import { createAction } from 'redux-actions';
import * as types from './actionTypes';

export const pencilListRequest = createAction(types.PENCIL_LIST_REQUEST);
export const pencilListSuccess = createAction(types.PENCIL_LIST_SUCCESS);
export const pencilListFailure = createAction(types.PENCIL_LIST_FAILURE);
export const pencilListReset = createAction(types.PENCIL_LIST_RESET);
export const pencilListPollingReset = createAction(
  types.PENCIL_LIST_POLLING_RESET,
);
export const pencilListPollingCancelledEvent = createAction(
  types.PENCIL_LIST_POLLING_CANCELLED_EVENT,
);

export const removeExpiredIncentivesRequest = createAction(
  types.REMOVE_EXPIRED_INCENTIVES_REQUEST,
);

export const removeUnavailableAccessoriesRequest = createAction(
  types.REMOVE_UNAVAILABLE_ACCESSORIES_REQUEST,
);

export default {
  pencilListRequest,
  pencilListSuccess,
  pencilListFailure,
  pencilListReset,
  removeExpiredIncentivesRequest,
  removeUnavailableAccessoriesRequest,
};
